import { EasterEgg } from "./easter_egg.js"
const easterEgg = new EasterEgg()